// eslint-disable-next-line no-restricted-imports
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { ConsentResource } from '../../resources';
import { consentsAtom } from '../../state';
import { GetResourceHeaderWithToken } from '../useResource';

export type ConsentsCommonProps = {
  consentResource: ConsentResource;
  getResourceHeaderWithToken: GetResourceHeaderWithToken;
};

export const useConsentsCommon = ({ getResourceHeaderWithToken, consentResource }: ConsentsCommonProps) => {
  const [consents, setConsents] = useAtom(consentsAtom);
  const getConsents = () => {
    return consents;
  };

  const updateConsent = useCallback(
    async (consentId: string, options: Array<string>) => {
      await consentResource.acceptConsent(
        {
          consentId: consentId,
          userId: getResourceHeaderWithToken().userid,
          acceptUserConsentRequest: { options },
        },
        {
          ...getResourceHeaderWithToken(),
        },
      );

      setConsents(previousConsents =>
        previousConsents.map(consent =>
          consent.consentId === consentId
            ? {
                ...consent,
                accepted: true,
              }
            : consent,
        ),
      );
    },
    [getResourceHeaderWithToken, consentResource, setConsents],
  );

  const resetConsent = useCallback(
    async (consentId: string) => {
      await consentResource.resetConsentApprove(
        {
          consentId: consentId,
          userId: getResourceHeaderWithToken().userid,
        },
        {
          ...getResourceHeaderWithToken(),
        },
      );

      setConsents(previousConsents =>
        previousConsents.map(consent => (consent.consentId === consentId ? { ...consent, accepted: false } : consent)),
      );
    },
    [getResourceHeaderWithToken, consentResource, setConsents],
  );

  return { getConsents, updateConsent, resetConsent };
};
